/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ThumbsDownFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M17.232 28a2 2 0 0 0 1.932-1.485l1.664-6.238a1 1 0 0 1 .259-.45l2.034-2.034a1 1 0 0 1 .707-.293H26a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H10.827a5 5 0 0 0-4.916 4.09l-1.457 7.864a3 3 0 0 0 2.95 3.546H13V25a3 3 0 0 0 3 3h1.232Z" />
    </BaseIcon>
  );
};
